export const imageServerRoot = '/imageserver';
export const dataServerRoot = '/dataserver';
